import {
  Component,
  DestroyRef,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { listCompanyObjects, logout } from 'src/app/core/actions/auth.actions';

import { AppFeatures } from 'src/app/core/app.features';
import { AppState } from 'src/app/reducers';
import { ChangePasswordDialogComponent } from '../../popups/change-password-dialog/change-password-dialog.component';
import { DialogService } from '@sui/dialog';
import { ObjectEditorService } from 'src/app/core/services/object-editor.service';
import { Store } from '@ngrx/store';
import { User } from 'src/app/core/models/core.models';
import { selectUser } from 'src/app/core/reducers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
  selector: 'app-dropdown-user',
  templateUrl: './dropdown-user.component.html',
  styleUrls: ['./dropdown-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropdownUserComponent {
  @Input() closeMethod!: () => void;

  AppFeatures = AppFeatures;

  private destroyRef = inject(DestroyRef);
  private dialogService = inject(DialogService);

  user: User;

  constructor(
    private store: Store<AppState>,
    private editService: ObjectEditorService,
  ) {}

  ngOnInit() {
    this.store
      .select(selectUser)
      .pipe(
        tap((user) => (this.user = user)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  onUserSettings() {
    this.closeMethod();
    this.editService.editUser(this.user.id);
  }

  onChangePassword() {
    this.closeMethod();

    this.dialogService.openTabsDialog(ChangePasswordDialogComponent, {
      data: {},
      closeOnClick: false,
      closeOnEscape: true,
      width: '20vw',
      height: '45vh',
      minWidth: 300,
      minHeight: 600,
      maxWidth: 400,
      maxHeight: 600,
    });
  }

  onLogout() {
    this.closeMethod();
    this.store.dispatch(logout());
  }

  toggleCompanyObjectsView(event: any) {
    event.stopPropagation();
  }

  handleCompanyObjectsToggle(checked: boolean) {
    this.store.dispatch(listCompanyObjects({ listCompanyObjects: checked }));
  }

  hasPerm(perm: AppFeatures) {
    return this.user.feature_components?.[perm] === true;
  }
}
